// extracted by mini-css-extract-plugin
module.exports = {"container":"DeepLinkBanner_container__3oHeE","image":"DeepLinkBanner_image__2nMUl","action":"DeepLinkBanner_action__2Y1Lt"};